import React, { Component } from 'react'
import { connect } from 'react-redux'
import Listing, { ListLoader, ErrorBox } from '../listing';
import {listAction} from "../../actions"

const listhoc = (ListComponent, actionName, reducerName, api) => {

    class List extends Component {

        componentDidMount(){
            this.props.dispatch(
                listAction("LOAD", actionName, api)
            );
        }
    
        render() {
            let {list, ...restProps} = this.props;
            let { fetching, error, data, next, nextFetching, nextError } = list;
            return (
               <div>
                    <Listing
                        ListComponent={ListComponent}  
                        fetching={fetching}
                        error={error}
                        data={data}
                        {...restProps}
                    />
                    {
                        next && !nextFetching &&
                        <div className="flex-center">
                            <button 
                                className="btn btn-link loadmore" 
                                onClick={() => this.props.dispatch(
                                    listAction("LOAD", actionName + "_NEXT", next)
                                )}
                            >
                                Load more
                            </button>
                        </div>
                    }
                    { nextFetching && <ListLoader /> }
                    { nextError && <ErrorBox errmsg="Something went wrong" /> }
               </div>
            )
        }
    
        componentWillMount(){
            this.props.dispatch(
                listAction("UNLOAD", actionName, api)
            );
        }
    
    }

    const mapStateToProps = (state) => ({
        list: state[reducerName],
        user: state.loginReducer.data
    })
    
    return connect(mapStateToProps)(List)
}

export default listhoc
